import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mojo-candidate-skill',
  templateUrl: './candidate-skill.component.html',
  styleUrls: ['./candidate-skill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateSkillComponent {
  @Input()
  skills: string[];

  trackElement = (index: number, item: string) => item;
}
